/* Global imports. */
import React from "react";
import KontentRichText from "@components/KontentRichText"

interface Props {
  numberOfColumns: number;
  col1Content: any;
  col2Content: any;
  col3Content: any;
  col4Content: any;
  reverseOrderSmallScreen: boolean;
}



const Columns = ({ numberOfColumns, col1Content, col2Content, col3Content, col4Content, reverseOrderSmallScreen }: Props) => {

  const colClass = (() => {
    switch(numberOfColumns) {
      case 2:
        return "sm:grid-cols-2";
      case 3:
        return "sm:grid-cols-3";
      case 4:
        return "sm:grid-cols-4";
      default: 
        return "sm:grid-cols-2";
    }
  })();

  return (
    <>
    
    <div className={`grid grid-cols-1 ${colClass} sm:gap-6 mb-6 mt-6`}>
      {
      numberOfColumns >= 2 && <>
        <div className={`w-full ${reverseOrderSmallScreen ? `order-last sm:order-first` : `order-first`}`}><KontentRichText value={col1Content} /></div>
        <div className={`w-full`}><KontentRichText value={col2Content} /></div>
      </>
      }
      {
      numberOfColumns >= 3 && <>
        <div><KontentRichText value={col3Content} /></div>
      </>
      }
      {
      numberOfColumns === 4 && <>
        <div><KontentRichText value={col4Content} /></div>
      </>
      }
    </div>
    
    {
    // Safelisting grid-cols-4 doesn't seem to work so adding a dummy div here
    numberOfColumns === 4 && <div className="sm:grid-cols-4 hidden"></div>
    }
    </>
  )
} 

export default Columns;
